import ZohoCrmIntegrationAPI from '../../api/zohoCrmIntegration';

const state = {
  status: {
    configured: false,
    connected: false,
    expires_at: null,
    api_domain: null,
  },
  uiFlags: {
    isFetchingStatus: false,
    isSearching: false,
    isMarking: false,
    isSearchingRecords: false,
    isCreatingNote: false,
  },
};

export const getters = {
  getStatus: $state => $state.status,
  getUIFlags: $state => $state.uiFlags,
  isConnected: $state => $state.status.connected === true,
};

export const actions = {
  fetchStatus: async ({ commit }) => {
    commit('SET_UI_FLAG', { isFetchingStatus: true });
    try {
      const { data } = await ZohoCrmIntegrationAPI.status();
      commit('SET_STATUS', data);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn('[zoho] status fetch failed:', error?.response?.status);
    } finally {
      commit('SET_UI_FLAG', { isFetchingStatus: false });
    }
  },

  getAuthorizeUrl: async () => {
    const { data } = await ZohoCrmIntegrationAPI.authorizeUrl();
    return data?.url;
  },

  disconnect: async ({ dispatch }) => {
    await ZohoCrmIntegrationAPI.disconnect();
    await dispatch('fetchStatus');
  },

  searchLeads: async ({ commit }, phone) => {
    commit('SET_UI_FLAG', { isSearching: true });
    try {
      const { data } = await ZohoCrmIntegrationAPI.searchLeads(phone);
      return data?.leads || [];
    } finally {
      commit('SET_UI_FLAG', { isSearching: false });
    }
  },

  markGestionPlus: async ({ commit }, leadId) => {
    commit('SET_UI_FLAG', { isMarking: true });
    try {
      const { data } = await ZohoCrmIntegrationAPI.markGestionPlus(leadId);
      return data;
    } finally {
      commit('SET_UI_FLAG', { isMarking: false });
    }
  },

  // Busca el registro destino (Leads + Deals/SDI) por teléfono con fallback a
  // email, para sincronizar una nota de contacto al CRM.
  searchRecords: async ({ commit }, { phone, email }) => {
    commit('SET_UI_FLAG', { isSearchingRecords: true });
    try {
      const { data } = await ZohoCrmIntegrationAPI.searchRecords(phone, email);
      return data?.records || [];
    } finally {
      commit('SET_UI_FLAG', { isSearchingRecords: false });
    }
  },

  createCrmNote: async ({ commit }, payload) => {
    commit('SET_UI_FLAG', { isCreatingNote: true });
    try {
      const { data } = await ZohoCrmIntegrationAPI.createCrmNote(payload);
      return data;
    } finally {
      commit('SET_UI_FLAG', { isCreatingNote: false });
    }
  },
};

export const mutations = {
  SET_STATUS($state, status) {
    $state.status = { ...$state.status, ...status };
  },
  SET_UI_FLAG($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
